import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../ReusableComponent/CIVIL/CivilrightSection/CivilrightSection.css";
import { FaYoutube } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import { FaTelegramPlane } from "react-icons/fa";
import { Link } from 'react-router-dom';
import { BASE_URL } from "../../insightConfig/insightConfig";

function SocialComponent() {
  const [socialLinks, setSocialLinks] = useState({
    WhatsApp: '#',
    Telegram: '#',
    YouTube: '#',
    Facebook: '#'
  });

  useEffect(() => {
    axios.get(`${BASE_URL}/getSocialLinks`)
      .then(res => {
        if (res.data && res.data.data) {
          const linksMap = {};
          res.data.data.forEach(link => {
            linksMap[link.Platform] = link.Url;
          });
          setSocialLinks(prev => ({ ...prev, ...linksMap }));
        }
      })
      .catch(err => console.error("Error fetching social links:", err));
  }, []);

  return (
    <>
      <div className="card-body SocialComponent-background flex-wrap">
                        <Link to={socialLinks.WhatsApp || "https://api.whatsapp.com/send?phone=919821333936"} target="_blank" className='text-decoration-none text-center flex-grow-1 py-3 bg-sky bg-success me-3'>
                            <FaWhatsapp className='fs-1 text-white mb-1 rounded-circle' />
                            <h5 className='fs-6 text-white'>Follow us on</h5>
                            <h6 className='fs-5 text-white'>Whatsapp</h6>
                        </Link>
                        <Link to={socialLinks.Telegram || "https://t.me/INSIGHTICS"} target="_blank" className='text-decoration-none text-center flex-grow-1 py-3 bg-sky'>
                            <FaTelegramPlane className='fs-1 text-white mb-1 rounded-circle' />
                            <h5 className='fs-6 text-white'>Follow us on</h5>
                            <h6 className='fs-5 text-white'>Telegram</h6>
                        </Link>
                        <Link to={socialLinks.YouTube || "https://www.youtube.com/@INSIGHTACADEMYIAS"} target="_blank" className='text-decoration-none text-center flex-grow-1 py-3 mt-3 bg-red me-3'>
                            <FaYoutube className='fs-1 text-white mb-1 rounded-circle' />
                            <h5 className='fs-6 text-white'>Follow us on</h5>
                            <h6 className='fs-5 text-white'>YouTube</h6>
                        </Link>
                        <Link to={socialLinks.Facebook || "#"} target="_blank" className='text-decoration-none text-center flex-grow-1 py-3 mt-3 bg-red bg-primary'>
                            <FaFacebook className='fs-1 text-white mb-1 rounded-circle' />
                            <h5 className='fs-6 text-white'>Follow us on</h5>
                            <h6 className='fs-5 text-white'>Facebook</h6>
                        </Link>
                    </div>
    </>
  )
}

export default SocialComponent;